import { useEffect, useState, RefObject } from "react";

// Hook to get the maximum height of child elements
const useMaxChildHeight = (ref: RefObject<HTMLElement>): number | undefined => {
  const [maxHeight, setMaxHeight] = useState<number>();

  useEffect(() => {
    const calculateMaxHeight = () => {
      if (ref.current) {
        const children = Array.from(ref.current.childNodes);
        const calculatedMaxHeight = children.reduce((top, element) => {
          return Math.max(top, (element as HTMLElement).scrollHeight);
        }, 0);

        setMaxHeight(calculatedMaxHeight);
      }
    };

    // Delay to ensure elements are rendered
    const timeoutId = setTimeout(calculateMaxHeight, 10);

    return () => clearTimeout(timeoutId);
  }, [ref]);

  return maxHeight;
};

export default useMaxChildHeight;
